export default {
  'menuDecoratePreview.title': 'Tablet Pro Preview',
  'menuDecoratePreview.preparingData': 'Preparing data...',
  'menuDecoratePreview.errors.load_qr_link_failed': 'Load qr link failed',
  'menuDecoratePreview.errors.no_qr_link':
    'No qr link yet. Please goto <a>Smart Ordering > QR Code > QR Code Download</a> to generate',
};
